import { render, staticRenderFns } from "./RelatorioFornecedorPreview.vue?vue&type=template&id=61f1611c&scoped=true"
import script from "./RelatorioFornecedorPreview.vue?vue&type=script&lang=js"
export * from "./RelatorioFornecedorPreview.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFornecedorPreview.vue?vue&type=style&index=0&id=61f1611c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f1611c",
  null
  
)

export default component.exports